import React from 'react';
import Footer from '../component/Footer';

const Ent = () => {
    return (
        <>
            <div className="container">
              
                <div className="text-center my-5">
                    <h1>Ear, Nose, and Throat (ENT)</h1>
                </div>

           
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            ENT (Ear, Nose, and Throat) surgery involves treating conditions and diseases affecting the ear,
                            nose, throat, and related areas of the head and neck. This includes procedures like tonsillectomies,
                            sinus surgeries, and treatment of hearing loss or balance issues.
                        </p>
                        <p>
                            We specialize in both pediatric and adult ENT conditions, ensuring comprehensive care for issues
                            such as sleep apnea, hearing impairments, and chronic sinusitis.
                        </p>
                        <p>
                            With advanced technology and a dedicated team of ENT specialists, we offer a wide range of treatments,
                            from minor procedures to more complex surgeries, with a focus on recovery and quality of life.
                        </p>
                    </div>
                </div>
            </div>

         
            <Footer />
        </>
    );
}

export default Ent;
